<template>
  <div class="main">
    <div class="header">
      <div>课程简介</div>
      <div @click="goback()">
        <Icon type="ios-redo-outline" />返回列表
      </div>
    </div>
    <div class="content">
      <div><img src="../../assets/images/exam.jpg" /></div>
      <div>
        <div class="content-title">课程名称：古典音乐</div>
        <div class="content-belong">
          <div>所属级别：高中英语</div>&nbsp;&nbsp;&nbsp;&nbsp;
          <div>所属科目：英语</div>
        </div>
      </div>
    </div>
    <div class="catalogue">课程目录</div>
    <Table :columns="tableColumns" :data="data" border style="margin: 10px 0">
      <template slot-scope="{ row }" slot="star">
        <div>
          <Rate :count="10" allow-half v-model="valueHalf" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="percent">
        <div>
          <Progress :percent="90" :stroke-color="['#108ee9', '#87d068']" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="oppera">
        <Button type="primary">去学习</Button>
        <Button type="warning">购买</Button>
      </template>
    </Table>
    <Table :columns="tableColumns" :data="data" border style="margin: 10px 0">
      <template slot-scope="{ row }" slot="star">
        <div>
          <Rate :count="10" allow-half v-model="valueHalf" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="percent">
        <div>
          <Progress :percent="90" :stroke-color="['#108ee9', '#87d068']" />
        </div>
      </template>
      <template slot-scope="{ row }" slot="oppera">
        <Button type="primary">去学习</Button>
        <Button type="warning">购买</Button>
      </template>
    </Table>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        valueHalf: 7.5,
        page: {
          totlal: 10,
          currentPage: 1,
          pageSize: 10
        },
        data: [
          { type: '题库', is_free: 1, old: '100', current: '80', percent: '80%', evaluation: '5' },
          { type: '题库', is_free: 1, old: '100', current: '80', percent: '80%', evaluation: '5' },
          { type: '题库', is_free: 1, old: '100', current: '80', percent: '80%', evaluation: '5' },
          { type: '题库', is_free: 1, old: '100', current: '80', percent: '80%', evaluation: '5' }
        ],
        tableColumns: [
          { title: "类型", key: "type", align: "center", minWidth: 120, },
          { title: "收费免费", key: "is_free", align: "center", minWidth: 120, },
          { title: "原价", key: "old", align: "center", minWidth: 120, },
          { title: "现价", key: "current", align: "center", minWidth: 120, },
          { title: "学习进度", slot: "percent", align: "center", minWidth: 120, },
          { title: "我的评价", minWidth: 120, slot: "star", align: "center" },
          { title: "操作", width: 250, slot: "oppera", align: "oppera" },
        ],
      }
    },
    components: {},
    computed: {},
    mounted() { },
    methods: {
      goback() {
        this.$router.push('/examinationBank')
      }
    }
  }
</script>
<style scoped lang="less">
  .main {
    padding: 20px;
    font-size: 20px;
    .catalogue {
      border-left: 3px solid rgb(247, 122, 5);
      padding-left: 10px;
      font-size: 15px;
    }
    .header {
      display: flex;
      justify-content: space-between;
      height: 40px;
      margin-bottom: 20px;
      i {
        transform: rotateY(180deg)
      }
      div:nth-child(1) {
        border-bottom: 3px solid coral;
        height: 30px;
        font-size: 17px;
      }
      div:nth-child(2) {
        color: coral;
        margin-right: 30px;
        line-height: 60px;
        cursor: pointer;
      }
    }
    .content {
      display: flex;
      text-align: left;
      line-height: 35px;
      div:nth-child(1) {
        img {
          width: 240px;
          height: 170px;
          margin-right: 20px;
        }
      }
      div:nth-child(2) {
        .content-belong {
          display: flex;
        }
        .content-profile {
          text-indent: 25px;
          text-align: left;
        }
      }
    }
  }
</style>
